import * as BN from 'bn.js';
import { EXCHANGE_API_ENDPOINT } from './constants';
import store from './store';
export const updateExchangeRate = async currency => {
  const uri = `${EXCHANGE_API_ENDPOINT}/currency/price/${currency}`;
  const response = await fetch(uri, {
    method: 'GET',
    mode: 'cors'
  }).then(res => res.json()).catch(() => undefined);
  const {
    data,
    success
  } = response || {};

  if (!success) {
    return undefined;
  }

  const {
    dispatch
  } = store;
  dispatch({
    type: 'UPDATE_EXCHANGE_RATE',
    payload: {
      currency,
      price: Number(data),
      updatedAt: Math.floor(Date.now() / 1000)
    }
  });
  return Number(data);
};
export const sumSystemCurrencyInFiat = (...systemCurrencies) => {
  const {
    getState
  } = store;
  return systemCurrencies.reduce((sum, currency) => {
    var _getState$currency$to;

    const exchangeRate = (_getState$currency$to = getState()[currency.token]) === null || _getState$currency$to === void 0 ? void 0 : _getState$currency$to.price;

    if (exchangeRate === undefined) {
      return sum;
    }

    const value = new BN.BN(currency.value).muln(exchangeRate);

    const _sum = sum.add(value);

    return _sum;
  }, new BN.BN(0));
};